import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function AdminCategories() {
  const queryClient = useQueryClient();
  const [isAdding, setIsAdding] = useState(false);
  const [formData, setFormData] = useState<any>({ type: 1, sortOrder: 0 });

  const { data: categories = [], isLoading } = useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const { data } = await axios.get('http://localhost:5000/api/categories');
      return data;
    }
  });

  const createMutation = useMutation({
    mutationFn: async (cat: any) => {
      const token = localStorage.getItem('access_token');
      await axios.post('http://localhost:5000/api/categories', cat, {
        headers: { Authorization: `Bearer ${token}` }
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories'] });
      setIsAdding(false);
      setFormData({ type: 0, sortOrder: 0 });
      toast.success('Kategori eklendi!');
    },
    onError: (e: any) => toast.error('Kategori eklenemedi: ' + (e.response?.data?.error || e.message))
  });

  const deleteMutation = useMutation({
    mutationFn: async (id: string) => {
      const token = localStorage.getItem('access_token');
      await axios.delete(`http://localhost:5000/api/categories/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories'] });
      toast.success('Kategori silindi!');
    },
    onError: (e: any) => toast.error('Kategori silinemedi: ' + (e.response?.data?.error || e.message))
  });

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    createMutation.mutate({
      ...formData,
      type: Number(formData.type),
      sortOrder: Number(formData.sortOrder),
      isActive: true
    });
  };

  if (isLoading) return <div className="p-8"><div className="skeleton h-64 w-full"></div></div>;

  return (
    <div className="p-6 animate-fade-in">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold">Kategori Yönetimi</h1>
          <p className="text-muted mt-2">Menü ve market kategorilerini oluşturun.</p>
        </div>
        <button onClick={() => setIsAdding(true)} className="btn btn-primary">
          <Plus size={20} /> Yeni Kategori
        </button>
      </div>

      {isAdding && (
        <div className="card mb-8">
          <h3 className="font-bold mb-4">Yeni Kategori Ekle</h3>
          <form onSubmit={handleSave} className="grid-2 gap-4">
            <div className="form-group col-span-2">
              <label className="form-label">Kategori Adı</label>
              <input required type="text" className="form-input" placeholder="Örn: Pizzalar" 
                value={formData.name || ''} onChange={e => setFormData({...formData, name: e.target.value})} />
            </div>
            
            <div className="form-group">
              <label className="form-label">Kategori Tipi</label>
              <select className="form-input" value={formData.type} onChange={e => setFormData({...formData, type: e.target.value})}>
                <option value="1">Yemek</option>
                <option value="2">Market</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Sıra (Sort Order)</label>
              <input type="number" className="form-input" 
                value={formData.sortOrder} onChange={e => setFormData({...formData, sortOrder: e.target.value})} />
            </div>
            
            <div className="col-span-2 flex gap-2 justify-end mt-4">
              <button type="button" onClick={() => setIsAdding(false)} className="btn btn-ghost">İptal</button>
              <button type="submit" className="btn btn-primary" disabled={createMutation.isPending}>Kaydet</button>
            </div>
          </form>
        </div>
      )}

      <div className="card p-0 overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-surface-2 border-b border-border">
              <th className="p-4 font-semibold text-sm">Kategori Adı</th>
              <th className="p-4 font-semibold text-sm">Tip</th>
              <th className="p-4 font-semibold text-sm">Sıra</th>
              <th className="p-4 font-semibold text-sm text-right">İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((c: any) => (
              <tr key={c.id} className="border-b border-border hover:bg-surface-2 transition">
                <td className="p-4 font-medium">{c.name}</td>
                <td className="p-4 text-muted text-sm">{c.type === 1 ? 'Yemek' : 'Market'}</td>
                <td className="p-4">{c.sortOrder}</td>
                <td className="p-4 text-right">
                  <button 
                    onClick={() => { if(confirm('Emin misiniz?')) deleteMutation.mutate(c.id); }} 
                    className="btn btn-sm btn-ghost text-error"
                  >
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))}
            {categories.length === 0 && (
              <tr>
                <td colSpan={4} className="p-8 text-center text-muted">Henüz kategori eklenmemiş.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
